import { ICategory } from "@/core/redux/types/specification-explore";
import { FinishedPart, IExploreProduct } from "./ISpecificationExplore";

export enum ExploreSectionsEventEnum {
  FirstProductCategory = "first-product-category",
  CompetitiveIndexSectionStatus = "competitive-index-section-status",
  CompetitiveIndexStream = "competitive-index-stream",
  CompetitiveIndex = "competitive-index",
  LocalPartnerSupportSectionStatus = "local-partner-support-section-status",
  LocalPartnerSupport = "local-partner-support",
  LocalPartnerSupportStream = "local-partner-support-stream",
  UserAndCommentCountSectionStatus = "user-and-comment-count-section-status",
  UserAndCommentCount = "user-and-comment-count",
  MatchedProductSectionStatus = "matched-product-section-status",
  MatchedProduct = "matched-product",
  ProducerScoreSectionStatus = "producer-score-section-status",
  ProducerScoreStream = "producer-score",
  CustomerInsightsIndexSectionStatus = "customer-insights-section-status",

  //moving
  UserAndCommentCountMoving = "user-and-comment-count-moving",
  LocalPartnerSupportMoving = "local-partner-support-moving",
  CompetitiveIndexMoving = "competitive-index-moving",
  ProducerScoreMoving = "producer-score-moving",

  //sorted 
  SortedLocalPartnerSupport = "sorted-local-partner-support",
  SortedCompetitiveIndex = "sorted-competitive-index",
  SortedProducerScore = "sorted-producer-score",

  //compare screen
  CandidateProductStatus = "candidate-product-status",

  // document answer (supplier responses)
  DocumentAnswerStatus = "document-answer-status",
  DocumentAnswerItemProgress = "document-answer-item-progress",
}


export interface IExploreSupabaseResponse {
  event: ExploreSectionsEventEnum;
  payload: IExploreSupabasePayloadResponse;
  type: string;
}
export interface IExploreSupabasePayloadResponse {
  product?: IExploreProduct | null;
  data?: IExploreProduct[] | null;
  section: number;
  category: ICategory;
  status: number;
}

export interface IExploreStatusSupabaseResponse {
  event: ExploreSectionsEventEnum;
  payload: {
    section: number;
    specificationId: string;
    status: number;
    finishedPart: FinishedPart;
  };
  type: string;
}

export interface IExploreSupabaseStatusPayloadResponse {
  section: number;
  specificationId: string;
  status: number;
}